import React, { useState, useEffect, useRef } from "react";
import { Modal } from "./Modal";
import "./AddSourceModal.css";
import { graphql, createFragmentContainer } from "react-relay";
import InlineNotification from "./InlineNotification";
import AddSubscriptionMutation from "../mutations/AddSubscriptionMutation";
import AddSmallScreenSubMutation from "../mutations/AddSmallScreenSubMutation";
import { useTheme } from "../contexts/ThemeContext";
import environment from "../Environment";
import { commitLocalUpdate } from "react-relay";
import AddFolderSmallScreenMutation from "../mutations/AddFolderSmallScreenMutation";

const NEW_SOURCE = "0059f7fa-ce07-4d43-8b1e-753b3e660c75";
const SELECT_FOLDER = "fda1e075-ee12-4c82-b27e-e2f9072689d3";

function AddSourceModalComponent(props) {
    const [isNewFolder, setIsNewFolder] = useState(false);
    const [selectedFolder, setSelectedFolder] = useState(SELECT_FOLDER);
    const [enteredName, setEnteredName] = useState(props.selectedSubName);
    const [enteredFolderName, setEnteredFolderName] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [isFolderEditing, setIsFolderEditing] = useState(false);
    const [status, setStatus] = useState("");
    const [selectedParentId, setSelectedParentId] = useState("");

    const [style, setStyle] = useState({
        modal: {
            width: "24rem",
            height: "auto",
        },
        newTextBox: {
            display: "block",
        },
    });

    const user_Subscription = props.user_Subscription;
    const theme = useTheme();

    function onCancelClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isFullScreenAddSourceModalActivated");
        });
    }

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode == 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    });

    function saveOnClick() {
        let sourceSubmit = "";
        let folderSubmit = "";
        let sourceValid = false;
        let folderValid = false;

        if (selectedFolder != SELECT_FOLDER) {
            if (isNewFolder) {
                if (enteredFolderName) {
                    folderValid = true;
                    folderSubmit = enteredFolderName;
                } else {
                    folderValid = false;
                    setStatus("Folder name cannot be empty!!");
                }
            } else {
                folderValid = true;
                folderSubmit = selectedFolder;
            }
        } else {
            folderValid = false;
            setStatus("Please select a valid folder name!!");
        }

        if (enteredName != "") {
            sourceValid = true;
            sourceSubmit = enteredName;
        } else {
            sourceValid = false;
            setStatus("Please enter a valid name!!");
        }

        if (folderValid && sourceValid) {
            let subName = sourceSubmit;
            if (isNewFolder == false) {
                let parent = atob(selectedParentId).split(":").pop();
                let source = atob(props.selectedSubId).split(":").pop();

                AddSmallScreenSubMutation(subName, parent, source, () => {
                    // console.log("Added a new subscription!");
                });

                commitLocalUpdate(environment, (store) => {
                    const record = store.getRoot().getLinkedRecord("settings");
                    record.setValue(
                        false,
                        "isFullScreenAddSourceModalActivated"
                    );
                });
            } else {
                console.log("Adding new folder...");
                let promise = new Promise(function (resolve, reject) {
                    AddFolderSmallScreenMutation(
                        enteredFolderName,
                        (newFolderId) => {
                            resolve(newFolderId);
                        }
                    );
                });
                promise.then(
                    (newFolderId) => {
                        let parent = atob(newFolderId).split(":").pop();
                        let source = atob(props.selectedSubId).split(":").pop();
                        AddSmallScreenSubMutation(subName, parent, source, () => {
                            // console.log("Added a new subscription!");
                        });
                    },
                    (folderId) => {}
                );

                commitLocalUpdate(environment, (store) => {
                    const record = store.getRoot().getLinkedRecord("settings");
                    record.setValue(
                        false,
                        "isFullScreenAddSourceModalActivated"
                    );
                });
                // console.log("New Folder");
            }
        } else {
            setStatus("Invalid entries!");
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        saveOnClick();
    }

    function onSelectChange(e) {
        e.preventDefault();
        setStatus("");
        setIsFolderEditing(false);
        setSelectedFolder(e.target.value);
        setSelectedParentId(
            e.target.options[e.target.selectedIndex].dataset.id
        );
        console.log(e.target.value);
    }

    useEffect(() => {
        if (selectedFolder === NEW_SOURCE) {
            // console.log("New Folder!!");
            setIsNewFolder(true);
            if (isNewFolder) {
                // console.log(enteredFolderName);
            }
        } else if (selectedFolder == SELECT_FOLDER) {
            setIsNewFolder(false);
            // console.log("Invalid folder!");
        } else {
            setIsNewFolder(false);
            // console.log("Selected folder is Valid!!");
            // console.log(selectedFolder);
        }
    });

    function nameFieldOnChange(e) {
        // setIsFolderEditing(true);
        setStatus("");
        setEnteredName(e.target.value);
    }

    function onFolderNameChange(e) {
        setStatus("");
        setEnteredFolderName(e.target.value);
    }

    useEffect(() => {
        // console.log(enteredFolderName);
    });

    return (
        <div>
            <form className="add-source-modal-form" onSubmit={onSubmit}>
                <div className="add-source-inputs">
                    <div>
                        {/*
									
								<label> Name </label>
								<input
									readOnly={true}
									onChange={nameFieldOnChange}
									className="standard-textfield-long"
									type="text"
									defaultValue={props.selectedSubName}
								/>
									*/}

                        <label
                            className={`theme-${theme.paragraph} source-name-label`}
                        >
                            {props.selectedSubName}
                        </label>
                    </div>
                    <div className={`source-select-container`}>
                        <div className={`source-container`}>
                            <label htmlFor={`source-select`}> Folder</label>

                            <select
                                id={`source-select`}
                                onChange={onSelectChange}
                                className={`source-select theme-${theme.light} theme-${theme.paragraph}`}
                                style={style}
                            >
                                <option className={``} value={SELECT_FOLDER}>
                                    --Select a folder--
                                </option>

                                {user_Subscription.edges.map((edge, key) =>
                                    edge.node.parent ? null : (
                                        <option
                                            key={key}
                                            value={edge.node.name}
                                            data-id={edge.node.id}
                                        >
                                            {edge.node.name}
                                        </option>
                                    )
                                )}
                                <option value={NEW_SOURCE}>
                                    {" "}
                                    &#128193; Create New Folder{" "}
                                </option>
                            </select>
                        </div>
                        {isNewFolder ? (
                            <div className="source-container">
                                <label>Name</label>
                                <input
                                    onChange={onFolderNameChange}
                                    className="standard-textfield-small"
                                    type="text"
                                />
                            </div>
                        ) : null}
                        <InlineNotification message={status} isActive={true} />
                    </div>
                </div>

                <div className="add-source-controls btn-group">
                    {" "}
                    <input
                        onClick={onCancelClick}
                        className="standard-action-button"
                        type="button"
                        value="Cancel"
                    />
                    <input
                        className="standard-action-button"
                        type="submit"
                        value="Save"
                    />
                </div>
            </form>
        </div>
    );
}

export default createFragmentContainer(AddSourceModalComponent, {
    user_Subscription: graphql`
        fragment AddSourceModalComponent_user_Subscription on SubscriptionNodeConnection {
            edges {
                node {
                    id
                    name
                    parent {
                        id
                    }
                }
            }
        }
    `,
});
